/* @flow */

import type { JSON } from 'common/types';

export default function withDefault<V, D: JSON>(
  extract: JSON => V,
  defaultValue: D
): JSON => V {
  return json => {
    if (json === null || typeof json === 'undefined') {
      return extract(defaultValue);
    }
    return extract(json);
  };
}
